import { getLast30DaysDateRange } from '../../../../../../utils/getLast30DaysDateRange'
import { SEARCH_FIELDS } from './consts'
import { IRiskScoreLogsFilters } from './types'

export const getDefaultRiskScoreLogsFilters = (): IRiskScoreLogsFilters => {
  const { startDate, endDate } = getLast30DaysDateRange()

  return {
    dateRange: { from: startDate, to: endDate },
    searchAdvanced: { field: SEARCH_FIELDS.EXTERNAL_USER_ID, query: '' },
  }
}
